import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import {UserTypes} from "root/DataFunctions/Constants";
import DropdownUsers from "root/ReactHookForm/ui/DropdownUsers";

const HookSubFormEdPsych = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateCarer = (val) =>
    {
    }

    return (
        <FieldsetContainer title='Educational Psychologist' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <div style={{marginTop: '10px', fontStyle: 'italic', color: 'var(--s360-icon-blue)'}}>If you know which the pupil's Educational Psychologist is, you can select them at this point.</div>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='col-form-label'>Select an Educational Psychologist (Use the filter to narrow down the list)</label>
                    <DropdownUsers name={sectionName + '.ed_psych_id'} user_type={UserTypes.EDUCATIONAL_PSYCHOLOGIST} isClearable={true} control={control} rules={{validate: validateCarer}}
                                                      placeHolder='Pick a Social Worker' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.ed_psych_id?.type === 'validate' && <ErrorDiv>Please select an educational psychologist</ErrorDiv>}

                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}

export default HookSubFormEdPsych;
